import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const GetAllSetupsExpenseCategories = async ({
  limit,
  page,
  search,
  status = true,
  use_for = "dropdown",
  with_than,
  other_than,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (status) queryList.push(`status=${status}`);
  if (use_for) queryList.push(`use_for=${use_for}`);

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/setup/${
      process.env.REACT_APP_VERSION_API
    }/personnel/expense-category?${queryList.join("&")}`,
    {
      params: {with_than, other_than},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetSetupsExpenseCategoriesById = async ({uuid}) => {
  const queryList = [];
  if (uuid) queryList.push(`uuid=${uuid}`);
  
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/setup/${
      process.env.REACT_APP_VERSION_API
    }/personnel/expense-category/view?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};